(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kr-editorial-style"] && !Shopify.designMode) return;
  try {
    const krUpdateHeader=()=>document.body.classList.toggle('kr-scrolled',window.scrollY>30);
  window.addEventListener('scroll',krUpdateHeader,{passive:true});krUpdateHeader();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kr-wholesale-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kr-wholesale-order')) {
  customElements.define('kr-wholesale-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.quantities = new Map();
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.selectors = [...this.querySelectorAll('[data-option-index]')];
      this.rows = this.querySelector('[data-rows]');
      this.submitButton = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.selectors.forEach(select => select.addEventListener('change', () => this.renderRows()));
      this.querySelector('form').addEventListener('submit', event => this.addItems(event));
      this.renderRows();
    }
    amount(value) { return this.money.format(value / 100); }
    renderRows() {
      const sizes = ['XS','S','M','L','XL','2XL','XXL','3XL','XXXL','4XL','XXXXL','5XL','XXXXXL'];
      const variants = this.variants.filter(v => this.selectors.every(s => v.options[Number(s.dataset.optionIndex)] === s.value));
      if (this.sizeIndex >= 0) variants.sort((a,b) => {
        const rank = v => { const i = sizes.indexOf(v.options[this.sizeIndex].toUpperCase()); return i < 0 ? 100 : i; };
        return rank(a) - rank(b);
      });
      this.rows.replaceChildren();
      variants.forEach(variant => {
        const row = document.createElement('div');
        row.className = 'kr-order-row';
        const label = document.createElement('label');
        const inputId = 'KrQuantity-' + variant.id;
        label.htmlFor = inputId;
        label.append(document.createTextNode(this.sizeIndex >= 0 ? variant.options[this.sizeIndex] : variant.title));
        const price = document.createElement('span');
        price.className = 'kr-order-price';
        price.textContent = '(' + this.amount(variant.price) + ')' + (variant.available ? '' : ' · ' + this.labels.sold);
        label.append(price);
        const controls = document.createElement('div');
        controls.className = 'kr-order-controls';
        const minus = document.createElement('button');
        minus.type = 'button'; minus.textContent = '−';
        minus.setAttribute('aria-label', this.labels.decrease + ' ' + variant.title);
        const input = document.createElement('input');
        input.type = 'number'; input.id = inputId; input.min = '0'; input.step = '1'; input.inputMode = 'numeric';
        input.value = this.quantities.get(variant.id) || 0;
        input.disabled = !variant.available;
        if (variant.max !== null) input.max = variant.max;
        input.setAttribute('aria-label', this.labels.quantity + ' ' + variant.title);
        const plus = document.createElement('button');
        plus.type = 'button'; plus.textContent = '+';
        plus.setAttribute('aria-label', this.labels.increase + ' ' + variant.title);
        const commit = () => {
          const value = Number(input.value);
          const valid = Number.isInteger(value) && value >= 0 && (value === 0 || (value >= variant.min && value % variant.step === 0)) && (variant.max === null || value <= variant.max);
          input.setCustomValidity(valid ? '' : this.labels.invalid);
          this.quantities.set(variant.id, valid ? value : 0);
          minus.disabled = !variant.available || value <= 0;
          plus.disabled = !variant.available || (variant.max !== null && value >= variant.max);
          this.updateTotal();
        };
        minus.addEventListener('click', () => { const n=Number(input.value)||0; input.value=n-variant.step < variant.min ? 0 : n-variant.step; commit(); });
        plus.addEventListener('click', () => { const n=Number(input.value)||0; input.value=n===0 ? variant.min : n+variant.step; commit(); });
        input.addEventListener('input', commit);
        controls.append(minus,input,plus); row.append(label,controls); this.rows.append(row); commit();
      });
      if (!variants.length) this.rows.textContent = this.labels.empty;
      this.updateTotal();
    }
    updateTotal() {
      let count=0, total=0;
      this.variants.forEach(v => { const n=this.quantities.get(v.id)||0; count+=n; total+=n*v.price; });
      this.querySelector('[data-total]').textContent = count + ' ' + this.labels.items + ' · ' + this.amount(total);
      this.submitButton.disabled = count===0 || this.busy;
    }
    async addItems(event) {
      event.preventDefault();
      if (this.busy || !this.querySelector('form').reportValidity()) return;
      const items = [...this.quantities].filter(([,quantity]) => quantity>0).map(([id,quantity]) => ({id,quantity}));
      if (!items.length) return;
      this.busy=true;
      this.querySelectorAll('input,select,button').forEach(el => el.disabled=true);
      this.status.textContent=this.labels.adding;
      try {
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.labels.error);
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.status.textContent=(error.message || this.labels.error) + ' ' + this.labels.error;
        this.busy=false;
        this.selectors.forEach(el=>el.disabled=false);
        this.renderRows();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
